<template>
  <div class="wa-sidebar" :class="{ 'wa-sidebar-open': sidebarVisible }">
    <!-- Sidebar Header -->
    <div class="wa-sidebar-header">
      <div class="d-flex align-items-center overflow-hidden flex-grow-1 me-2">
        <button class="btn wa-icon-btn d-lg-none me-2 text-white p-0 flex-shrink-0"
          @click="$emit('update:sidebarVisible', false)" title="Volver al chat">
          <i class="mdi mdi-arrow-left font-size-22"></i>
        </button>
        <div class="wa-my-avatar me-2 flex-shrink-0">
          <i class="mdi mdi-domain font-size-20 text-white"></i>
        </div>
        <span class="fw-semibold text-white font-size-15 text-truncate" :title="nombreEmpresa">
          {{ nombreEmpresa }}
        </span>
        <span v-if="cargandoConversaciones" class="spinner-border spinner-border-sm text-white-50 ms-2 flex-shrink-0"
          role="status" style="width: 14px; height: 14px;" title="Sincronizando conversaciones..."></span>
      </div>
      <div class="wa-header-actions flex-shrink-0">
        <div class="dropdown d-inline-block">
          <button class="btn wa-icon-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Menú">
            <i class="mdi mdi-dots-vertical"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <a class="dropdown-item font-size-13" href="javascript:void(0);"
                @click="$emit('abrir-modal-inicializar-conversacion')">
                <i class="mdi mdi-chat-plus-outline text-success me-2 font-size-16"></i>Iniciar conversación
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Search Bar -->
    <div class="wa-search-container">
      <div class="wa-search-input-wrap">
        <i class="mdi mdi-magnify wa-search-icon"></i>
        <input type="text" class="form-control wa-search-input" placeholder="Buscar chat" :value="busqueda"
          @input="onInputBusqueda" @keyup.enter="onEnterBusqueda" />
        <button v-if="busqueda" class="btn btn-sm p-0 wa-clear-btn" @click="limpiarBusqueda">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
    </div>

    <!-- Tabs Selector (Recientes / Archivados) -->
    <div class="wa-filter-tabs">
      <button class="wa-tab-btn" :class="{ 'wa-tab-active': tabActiva === 'recientes' }"
        @click="cambiarTab('recientes')">
        <i class="mdi mdi-chat-outline me-1"></i>
        Recientes
        <span v-if="totalNoLeidos > 0" class="badge rounded-pill wa-badge-unread ms-1">
          {{ totalNoLeidos }}
        </span>
      </button>
      <button class="wa-tab-btn" :class="{ 'wa-tab-active': tabActiva === 'archivados' }"
        @click="cambiarTab('archivados')">
        <i class="mdi mdi-archive-outline me-1"></i>
        Archivados
        <span v-if="totalArchivados > 0" class="badge rounded-pill bg-secondary ms-1">
          {{ totalArchivados }}
        </span>
      </button>
    </div>

    <!-- Contacts List -->
    <SimpleBar class="wa-contacts-scroll" data-simplebar>
      <div v-if="cargandoConversaciones && chatsAMostrar.length === 0" class="text-center py-5 px-3 text-muted">
        <div class="spinner-border text-success spinner-border-sm mb-2" role="status"></div>
        <div class="font-size-13">Cargando conversaciones...</div>
      </div>

      <div v-else-if="chatsAMostrar.length === 0" class="text-center py-5 px-3 text-muted">
        <i :class="tabActiva === 'archivados' ? 'mdi mdi-archive-off-outline' : 'mdi mdi-chat-remove-outline'"
          class="font-size-24 d-block mb-2 text-secondary"></i>
        <span class="font-size-13">
          {{ tabActiva === 'archivados' ? 'No hay chats archivados' : 'No se encontraron conversaciones' }}
        </span>
      </div>

      <TransitionGroup v-else name="wa-contacts" tag="div" class="wa-contacts-list">
        <div v-for="chat in chatsAMostrar" :key="obtenerKeyChat(chat)" class="wa-contact-item"
          :class="{ 'wa-active': esChatActivo(chat) }" @click="$emit('seleccionar-chat', chat)">
          <!-- Dual Avatar -->
          <CmpDualAvatar :id-cliente="obtenerIdCliente(chat)" :avatar-cliente="chat.avatarCliente || null"
            :avatar-whatsapp="chat.avatarWhatsapp || null" :nombre="obtenerNombre(chat)" :inicial="obtenerInicial(chat)"
            :es-varios="esClienteGenerico(chat)" />

          <!-- Contact Info snippet -->
          <div class="wa-contact-info">
            <div class="d-flex justify-content-between align-items-baseline mb-1">
              <span class="wa-contact-name text-truncate">
                <i v-if="chat.fijado" class="mdi mdi-pin font-size-13 me-1 text-muted"></i>
                <i v-if="Boolean(Number(chat.bloqueado))" class="mdi mdi-block-helper font-size-13 me-1 text-danger" title="Número bloqueado"></i>
                {{ obtenerNombre(chat) }}
                <small v-if="!esClienteGenerico(chat) && chat.numero" class="text-muted font-size-11 ms-1">({{
                  chat.numero }})</small>
                <span v-if="chat.principal"
                  class="badge bg-soft-warning text-warning font-size-10 ms-1">Principal</span>
              </span>
              <span class="wa-contact-time" :class="{ 'text-success fw-bold': esEntranteNoLeido(chat) }">{{
                obtenerHora(chat) }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <p class="wa-contact-snippet text-truncate mb-0" :class="{
                'fw-semibold text-dark': esEntranteNoLeido(chat) && !esMensajeUnsupported(chat),
                'text-danger fw-medium': esMensajeUnsupported(chat)
              }">
                <i v-if="chat.silenciado" class="mdi mdi-volume-variant-off font-size-13 me-1 text-muted"></i>
                <i v-if="esMensajeUnsupported(chat)" class="mdi mdi-alert-circle text-danger font-size-13 me-1"
                  title="Mensaje no compatible"></i>
                <i v-else-if="esSaliente(chat) && obtenerUltimoMensaje(chat)"
                  :class="obtenerClasePalomitas(obtenerUltimoMensaje(chat))" class="font-size-14 me-1"></i>
                {{ esMensajeUnsupported(chat) ? 'Mensaje no compatible' : (obtenerUltimoTexto(chat) || '...') }}
              </p>
              <div class="d-flex align-items-center gap-1">
                <span v-if="esEntranteNoLeido(chat)" class="badge rounded-pill wa-badge-unread">
                  {{ cantidadNoLeidos(chat) }}
                </span>
                <!-- Dropdown de más opciones -->
                <div class="dropdown wa-contact-menu" @click.stop>
                  <button class="btn btn-sm wa-contact-menu-btn p-0" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false" title="Opciones de chat">
                    <i class="mdi mdi-chevron-down"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                    <li>
                      <a class="dropdown-item font-size-13" href="javascript:void(0);"
                        @click.stop="$emit('abrir-modal-asignar-cliente', chat)">
                        <i class="mdi mdi-account-arrow-right text-success me-2"></i>{{ esClienteGenerico(chat) ?
                          'Asignar cliente' : 'Cambiar cliente' }}
                      </a>
                    </li>
                    <li v-if="!esClienteGenerico(chat) && obtenerIdCliente(chat)">
                      <router-link
                        :to="{ name: 'tableroCliente', params: { id_cliente: obtenerIdCliente(chat) } }"
                        target="_blank"
                        class="dropdown-item font-size-13"
                        @click.stop
                      >
                        <i class="mdi mdi-account-box-outline text-primary me-2"></i>Ver tablero del cliente
                      </router-link>
                    </li>
                    <li>
                      <a v-if="!esContactoArchivado(chat)" class="dropdown-item font-size-13" href="javascript:void(0);"
                        @click.stop="$emit('archivar-contacto', chat)">
                        <i class="mdi mdi-archive-arrow-down-outline text-warning me-2"></i>Archivar chat
                      </a>
                      <a v-else class="dropdown-item font-size-13" href="javascript:void(0);"
                        @click.stop="$emit('desarchivar-contacto', chat)">
                        <i class="mdi mdi-archive-arrow-up-outline text-success me-2"></i>Desarchivar chat
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item font-size-13 text-secondary" href="javascript:void(0);"
                        @click.stop="$emit('vaciar-chat', chat)">
                        <i class="mdi mdi-broom me-2 text-warning"></i>Vaciar chat
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item font-size-13 text-info" href="javascript:void(0);"
                        @click.stop="accionMarcarNoLeido(chat)">
                        <i class="mdi mdi-email-mark-as-unread me-2 text-info"></i>Marcar como no leído
                      </a>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li v-if="!Boolean(Number(chat.bloqueado))">
                      <a class="dropdown-item font-size-13 text-danger" :class="{ 'disabled text-muted': procesandoBloqueo }" href="javascript:void(0);"
                        @click.stop="accionBloquear(chat)">
                        <i class="mdi me-2" :class="procesandoBloqueo ? 'mdi-loading mdi-spin' : 'mdi-block-helper'"></i>Bloquear número
                      </a>
                    </li>
                    <li v-else>
                      <a class="dropdown-item font-size-13 text-success" :class="{ 'disabled text-muted': procesandoBloqueo }" href="javascript:void(0);"
                        @click.stop="accionDesbloquear(chat)">
                        <i class="mdi me-2" :class="procesandoBloqueo ? 'mdi-loading mdi-spin' : 'mdi-lock-open-outline'"></i>Desbloquear número
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item font-size-13 text-danger" href="javascript:void(0);"
                        @click.stop="$emit('eliminar-chat', chat)">
                        <i class="mdi mdi-chat-remove-outline me-2"></i>Eliminar chat
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item font-size-13 text-danger" href="javascript:void(0);"
                        @click.stop="$emit('eliminar-telefono-cliente', chat)">
                        <i class="mdi mdi-phone-remove-outline me-2"></i>Eliminar número de teléfono
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </SimpleBar>

    <!-- Paginador Footer del Sidebar -->
    <div v-if="totpag > 1 || (epp && epp > 0)" class="wa-sidebar-pagination">
      <Paginador :pag="pag" :totpag="totpag" :epp="epp" :max-botones="3" @cargar-pagina="$emit('cargar-pagina', $event)"
        @epp-actualizado="$emit('epp-actualizado', $event)" />
    </div>
  </div>
</template>

<script>
import { SimpleBar } from "simplebar-vue3";
import CmpDualAvatar from "./CmpDualAvatar.vue";
import Paginador from "@/components/Paginador.vue";
import { obtenerClasePalomitas } from "./whatsappHelpers.js";

export default {
  name: "CmpSidebarChats",
  components: {
    SimpleBar,
    CmpDualAvatar,
    Paginador
  },
  props: {
    conversaciones: {
      type: Array,
      default: () => []
    },
    conversacionesArchivadas: {
      type: Array,
      default: null
    },
    totalArchivadosServidor: {
      type: Number,
      default: null
    },
    totalNoLeidosServidor: {
      type: Number,
      default: null
    },
    chatActivoId: {
      type: [Number, String],
      default: null
    },
    sidebarVisible: {
      type: Boolean,
      default: false
    },
    tabActiva: {
      type: String,
      default: "recientes"
    },
    busqueda: {
      type: String,
      default: ""
    },
    cargandoConversaciones: {
      type: Boolean,
      default: false
    },
    pag: {
      type: Number,
      default: 1
    },
    totpag: {
      type: Number,
      default: 1
    },
    epp: {
      type: Number,
      default: 10
    },
    procesandoBloqueo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nombreEmpresaLocal: "",
      timerBusqueda: null
    };
  },
  mounted() {
    const nom = sessionStorage.getItem("nombreEmpresa");
    if (!nom) {
      SistemaSrv.nombreEmpresa()
        .then((res) => {
          if (res && res.data) {
            this.nombreEmpresaLocal = res.data;
            sessionStorage.setItem("nombreEmpresa", res.data);
          }
        })
        .catch(() => { });
    } else {
      this.nombreEmpresaLocal = nom;
    }
  },
  beforeUnmount() {
    if (this.timerBusqueda) {
      clearTimeout(this.timerBusqueda);
      this.timerBusqueda = null;
    }
  },
  emits: [
    "update:sidebarVisible",
    "update:tabActiva",
    "update:busqueda",
    "buscar",
    "cambiar-tab",
    "seleccionar-chat",
    "ir-a-detalle-cliente",
    "archivar-contacto",
    "desarchivar-contacto",
    "marcar-no-leido",
    "fijar-contacto",
    "silenciar-contacto",
    "vaciar-chat",
    "bloquear-contacto",
    "desbloquear-contacto",
    "eliminar-chat",
    "cargar-pagina",
    "epp-actualizado"
  ],
  computed: {
    nombreEmpresa() {
      return this.nombreEmpresaLocal || sessionStorage.getItem("nombreEmpresa") || "WhatsApp";
    },
    chatsAMostrar() {
      const esArchivado = this.tabActiva === "archivados";
      const origen = esArchivado && Array.isArray(this.conversacionesArchivadas)
        ? this.conversacionesArchivadas
        : this.conversaciones;
      if (!Array.isArray(origen)) return [];
      let lista = origen.filter((c) => c && (Boolean(Number(c.archivado)) === esArchivado));

      if (this.busqueda && this.busqueda.trim()) {
        const query = this.busqueda.trim().toLowerCase();
        const queryNumeros = query.replace(/\D/g, "");
        lista = lista.filter((c) => {
          const nombre = (this.obtenerNombre(c) || "").toLowerCase();
          const numero = (c.numero || "").replace(/\D/g, "");
          const idCli = String(c.id_cliente || (c.cliente && c.cliente.id) || "");
          const ultimoTexto = (this.obtenerUltimoTexto(c) || "").toLowerCase();

          return (
            nombre.includes(query) ||
            (queryNumeros && numero.includes(queryNumeros)) ||
            idCli.includes(query) ||
            ultimoTexto.includes(query)
          );
        });
      }

      return lista;
    },
    totalNoLeidos() {
      if (this.totalNoLeidosServidor !== null && this.totalNoLeidosServidor !== undefined) {
        return Math.min(Number(this.totalNoLeidosServidor) || 0, 99);
      }
      return this.conversaciones.filter((c) => c && !Number(c.archivado) && this.esEntranteNoLeido(c)).length;
    },
    totalArchivados() {
      if (this.totalArchivadosServidor !== null && this.totalArchivadosServidor !== undefined) {
        return Number(this.totalArchivadosServidor) || 0;
      }
      if (Array.isArray(this.conversacionesArchivadas)) {
        return this.conversacionesArchivadas.length;
      }
      if (!Array.isArray(this.conversaciones)) return 0;
      return this.conversaciones.filter((c) => c && Number(c.archivado) === 1).length;
    }
  },
  methods: {
    obtenerClasePalomitas,
    obtenerIdCliente(chat) {
      if (!chat) return null;
      return chat.id_cliente || (chat.cliente && chat.cliente.id) || null;
    },
    esContactoArchivado(chat) {
      if (!chat) return false;
      return Boolean(Number(chat.archivado));
    },
    obtenerKeyChat(chat) {
      if (!chat) return Math.random();
      const idCli = chat.id_cliente || (chat.cliente && chat.cliente.id) || "";
      const idTel = chat.id || chat.id_telefono_cliente || "";
      const num = chat.numero || "";
      return `chat_${idTel}_${idCli}_${num}`;
    },
    esChatActivo(chat) {
      if (!chat || !this.chatActivoId) return false;
      const id = chat.id || chat.id_telefono_cliente || chat.id_cliente;
      return String(id) === String(this.chatActivoId);
    },
    obtenerIdChat(chat) {
      if (!chat) return null;
      return chat.id || chat.id_telefono_cliente || chat.id_cliente;
    },
    esClienteGenerico(chat) {
      if (!chat) return true;
      const nom = ((chat.cliente && chat.cliente.nombre) || chat.nombre || "").toLowerCase().trim();
      return (chat.cliente && chat.cliente.generico) || nom === "varios" || nom.includes("publico en general");
    },
    obtenerNombre(chat) {
      if (this.esClienteGenerico(chat)) {
        return (chat.prefijo ? chat.prefijo + " " : "") + (chat.numero || "Sin número");
      }
      if (chat.cliente && chat.cliente.nombre) {
        return `${chat.cliente.nombre} ${chat.cliente.apellido_paterno || ""} ${chat.cliente.apellido_materno || ""}`.trim();
      }
      return chat.nombre || chat.numero || "Sin nombre";
    },
    obtenerInicial(chat) {
      const nombre = (chat && chat.cliente && chat.cliente.nombre) || (chat && chat.nombre) || "C";
      return nombre.charAt(0).toUpperCase();
    },
    obtenerUltimoMensaje(chat) {
      if (!chat) return null;
      const msg = chat.ultimo_mensaje_whatssap || chat.ultimo_mensaje_whatsapp || chat.ultimo_mensaje;
      if (msg) return msg;
      if (Array.isArray(chat.mensajes) && chat.mensajes.length > 0) {
        return chat.mensajes[chat.mensajes.length - 1];
      }
      return null;
    },
    extraerTexto(val) {
      if (!val) return "";
      if (typeof val === "string") {
        if (val.trim().startsWith("{") || val.trim().startsWith("[")) {
          try { return this.extraerTexto(JSON.parse(val)); } catch (e) { return val; }
        }
        return val;
      }
      if (typeof val === "object") {
        if (val.meta_request) return this.extraerTexto(val.meta_request);
        if (val.cuerpo) return this.extraerTexto(val.cuerpo);
        if (val.mensaje) return this.extraerTexto(val.mensaje);
        if (val.texto) return this.extraerTexto(val.texto);
        if (val.body && typeof val.body === "string") return val.body;
        if (val.text) return typeof val.text === "object" ? (val.text.body || "") : val.text;
        if (val.caption) return val.caption;
        if (val.image?.caption) return val.image.caption;
        if (val.video?.caption) return val.video.caption;
        if (val.document?.caption) return val.document.caption;
        if (val.payload) return this.extraerTexto(val.payload);

        // Multimedia & special labels
        const t = val.type || val.tipo;
        if (t === "reaction" || val.reaction) {
          const emoji = val.reaction?.emoji || val.emoji || "";
          return emoji ? `Reaccionó con ${emoji}` : "Reacción";
        }
        if (t === "template" || val.plantilla || val.meta_payload?.type === "template") {
          return val.cuerpo || val.mensaje || "Comprobante de pago";
        }
        if (t === "image" || val.image) return val.image?.caption || "Foto";
        if (t === "video" || val.video) return val.video?.caption || "Video";
        if (t === "audio" || val.audio || val.voice) return "Audio";
        if (t === "sticker" || val.sticker) return "Sticker";
        if (t === "document" || val.document) return val.document?.caption || val.document?.filename || "Documento";
        if (t === "location" || val.location) return "Ubicación";
        if (t === "unsupported") return "Mensaje no compatible";
      }
      return "";
    },
    esMensajeUnsupported(chat) {
      const msg = this.obtenerUltimoMensaje(chat);
      if (!msg) return false;
      return (msg.tipo || msg.type) === "unsupported";
    },
    obtenerUltimoTexto(chat) {
      if (!chat) return "";
      const msg = this.obtenerUltimoMensaje(chat);
      if (msg) return this.extraerTexto(msg);
      return this.extraerTexto(chat.texto || chat.mensaje || "");
    },
    obtenerHora(chat) {
      const msg = this.obtenerUltimoMensaje(chat);
      const fechaStr = msg ? (msg.created_at || msg.fecha_envio || msg.fecha_entrega || msg.updated_at || msg.timestamp) : null;
      if (fechaStr) {
        if (typeof fechaStr === "number" || (!isNaN(fechaStr) && !isNaN(parseFloat(fechaStr)) && String(fechaStr).length >= 10 && !String(fechaStr).includes("-"))) {
          const ts = Number(fechaStr) * (String(fechaStr).length === 10 ? 1000 : 1);
          const d = new Date(ts);
          if (!isNaN(d.getTime())) return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        }
        const d = new Date(String(fechaStr).replace(" ", "T"));
        if (!isNaN(d.getTime())) {
          return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        }
      }
      return chat.tiempo || "";
    },
    esSaliente(chat) {
      const msg = this.obtenerUltimoMensaje(chat);
      if (!msg) return false;
      if (msg.direccion === "saliente") return true;
      if (msg.direccion === "entrante") return false;
      if (typeof msg.id === "string" && msg.id.startsWith("temp_")) return true;
      let p = msg.payload;
      if (typeof p === "string" && (p.startsWith("{") || p.startsWith("["))) {
        try { p = JSON.parse(p); } catch (e) { p = {}; }
      }
      if (p?.direccion === "saliente") return true;
      if (p?.direccion === "entrante") return false;
      return false;
    },
    esEntranteNoLeido(chat) {
      if (!chat || (this.chatActivoId && this.esChatActivo(chat))) return false;
      return this.cantidadNoLeidos(chat) > 0;
    },
    cantidadNoLeidos(chat) {
      if (!chat || (this.chatActivoId && this.esChatActivo(chat))) return 0;
      if (chat.mensajes_sin_leer !== undefined && chat.mensajes_sin_leer !== null) {
        return Number(chat.mensajes_sin_leer) || 0;
      }
      if (chat.noLeidos !== undefined && chat.noLeidos !== null) {
        return Number(chat.noLeidos) || 0;
      }
      return 0;
    },
    onInputBusqueda(e) {
      const valor = e.target.value;
      this.$emit("update:busqueda", valor);
      if (this.timerBusqueda) {
        clearTimeout(this.timerBusqueda);
      }
      this.timerBusqueda = setTimeout(() => {
        this.timerBusqueda = null;
        this.$emit("buscar", valor);
      }, 400);
    },
    onEnterBusqueda(e) {
      if (this.timerBusqueda) {
        clearTimeout(this.timerBusqueda);
        this.timerBusqueda = null;
      }
      const valor = e.target.value;
      this.$emit("update:busqueda", valor);
      this.$emit("buscar", valor);
    },
    limpiarBusqueda() {
      if (this.timerBusqueda) {
        clearTimeout(this.timerBusqueda);
        this.timerBusqueda = null;
      }
      this.$emit("update:busqueda", "");
      this.$emit("buscar", "");
    },
    cambiarTab(tab) {
      this.$emit("update:tabActiva", tab);
      this.$emit("cambiar-tab", tab);
    },
    cerrarTodosDropdowns() {
      // Disparar click en document para cerrar cualquier dropdown abierto de Bootstrap
      document.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
    },
    accionMarcarNoLeido(chat) {
      this.cerrarTodosDropdowns();
      this.$emit("marcar-no-leido", chat);
    },
    accionBloquear(chat) {
      if (this.procesandoBloqueo) return;
      this.cerrarTodosDropdowns();
      this.$emit("bloquear-contacto", chat);
    },
    accionDesbloquear(chat) {
      if (this.procesandoBloqueo) return;
      this.cerrarTodosDropdowns();
      this.$emit("desbloquear-contacto", chat);
    }
  }
};
</script>
